import Typography from "component-lib/Base/components/Typography"
import map from "lodash/map"
import { useState } from "react"
import ReactHtmlParser from "react-html-parser"
import JSZip from "jszip"
import JSZipUtils from "jszip-utils"
import { ReactSVG } from "react-svg"
import Box from "component-lib/Base/components/Box"
import { makeStyles } from "tss-react/mui"
import getContentUrl from "utils-lib/getContentUrl"
import { wmColor } from "themes-lib/wmTheme"
import { isPdfUrl } from "utils-lib/validation/validateHashTagUrl"
import { getWindow } from "utils-lib/getWindow"
import Downloadcard from "./components/DownloadCard"
import FaqCard from "./components/FaqCard"
import GridCard from "./components/GridCard"
import ProfileCard from "./components/ProfileCard"
import ProductInfoCard from "./components/ProductInfoCard"
import ServiceSolutionCard from "./components/ServiceSolutionCard"
import WmContentCard from "./components/WmContentCard"
import ContentPreviewCard from "./components/ContentPreviewCard"
import ContentPreviewList from "./components/ContentPreviewList"
import { ButtonPrimary } from "../../Base"
import "./CardGrid.scss"
import NextImageWrapper from "../../SSR/NextImageWrapper"

const ssrWindow = getWindow()

const useStyles = makeStyles()(
  (theme, { backgroundColor, listView, cardType }) => ({
    contentPreviewCta: {
      padding: 0,
      margin: `${listView ? `0 0 32px 0` : `16px 0 32px 0`}`,
      "& button": {
        width: `${listView ? `190px !important` : `140px !important`}`,
      },
      [theme.breakpoints.down(`md`)]: {
        "& button": {
          width: `100% !important`,
        },
        margin: `${listView ? `16px 0 32px 0 ` : `0 16px 24px`}`,
      },
      [theme.breakpoints.down(`sm`)]: {
        margin: `${listView ? `55px 0` : `16px auto`}`,
        width: `${listView ? `100%` : `140px !important`}`,
      },
    },
    yellowBGColor: {
      "& button": {
        color:
          backgroundColor === "green1" ? `${wmColor.green1} !important` : ``,
        backgroundColor:
          backgroundColor === "green1"
            ? `${wmColor.primaryYellow} !important`
            : "",
      },
      "& button:hover": {
        color:
          backgroundColor === "green1" ? `${wmColor.green1} !important` : ``,
        backgroundColor:
          backgroundColor === "green1"
            ? `${wmColor.primaryYellow} !important`
            : "",
      },
    },
    headingbutton: {
      display: "flex",
      justifyContent: "space-between",
      [theme.breakpoints.down(`sm`)]: {
        padding: `${listView ? `0 9px` : ""}`,
      },
    },
    collapsebutton: {
      paddingTop: `35px`,
      marginLeft: `auto`,
      display: `${listView ? `none` : ""}`,
      [theme.breakpoints.down(`sm`)]: {
        marginRight: `13px`,
        paddingTop: `${cardType === "contentPreviewCard" ? "12px" : "35px"}`,
      },
      [theme.breakpoints.down(`md`)]: {
        paddingTop: `${cardType === "contentPreviewCard" ? "25px" : "35px"}`,
      },
    },
    horizontalline: {
      width: `100%`,
      borderTop: `1px solid ${wmColor.gray3}`,
      height: `33px`,
      display: `${listView ? `none` : ""}`,
    },
    expanded: {
      transition: `max-height 0.3s ease-in-out`,
      overflow: `hidden`,
      visibility: `visible `,
      maxHeight: `100%`,
    },
    collapsed: {
      maxHeight: `0`,
      maxWidth: `0`,
      visibility: `hidden`,
      transition: `max-height 0.3s ease-in-out`,
    },
    title: {
      color: wmColor.green1,
      paddingLeft: `${
        cardType === "contentPreviewCard" ? (listView ? "19px" : "16px") : "1%"
      }`,
      paddingTop: "32px",
      paddingBottom: `${listView ? `50px` : `16px`}`,

      [theme.breakpoints.down("xl")]: {
        paddingLeft: `${
          cardType === "contentPreviewCard" ? (listView ? "0" : "16px") : "1%"
        }`,
        paddingBottom: `${listView ? `39px` : ""}`,
      },
      [theme.breakpoints.down("lg")]: {
        paddingTop: "29px",
        fontSize: "24px",
        LineHeight: "30px",
        paddingBottom: `${listView ? `22px` : ""}`,
      },
    },
    cardbody: {
      fontSize: "16px",
      padding: `${
        cardType === "contentPreviewCard"
          ? listView
            ? "0 19px"
            : "0 16px"
          : "0 0 0 15px"
      }`,
      [theme.breakpoints.down("xl")]: {
        paddingLeft: `${
          cardType === "contentPreviewCard" ? (listView ? "0" : "16px") : "15px"
        }`,
      },
      [theme.breakpoints.down("lg")]: {
        padding: `${listView ? "0 9px" : ""}`,
      },
      fontFamily: "Maax-Regular",
      lineHeight: "24px",
      color: `${cardType === "contentPreviewCard" ? wmColor.gray5 : ""}`,
    },
    cardwrapper: {
      paddingBottom: `${cardType === "contentPreviewCard" ? "0" : "2rem"}`,
      gap: `${cardType === "contentPreviewCard" ? `24px !important` : ""}`,
      [theme.breakpoints.down(`md`)]: {
        gap: `16px !important`,
      },
      [theme.breakpoints.down(`sm`)]: {
        gap: `${listView ? `35px !important` : `0 !important`}`,
      },
    },
  }),
)

const CardGrid = ({
  cardList,
  cardType = "",
  componentHeading = "",
  componentCtaText = "",
  componentCtaURL = "",
  analyticsKey = "",
  backgroundColor = "",
  collapseGrid = false,
  downloadButtonText = "",
  body = "",
  contentPreviewCardsList = [],
  listView = false,
  componentId = "",
  nextImageloadingStrategy = `eager`,
  nextImagePriority = false,
}) => {
  const [collapseCardGrid, setcollapseCardGrid] = useState(collapseGrid)
  const { classes } = useStyles({ backgroundColor, listView, cardType })

  const handleClick = (path) => {
    isPdfUrl(path) ? ssrWindow.open(path) : (ssrWindow.location = path)
  }

  const pageUrl = ssrWindow.location.pathname

  const togglecollapsecard = () => {
    setcollapseCardGrid(!collapseCardGrid)
  }

  function urlToPromise(url) {
    return new Promise((resolve, reject) => {
      JSZipUtils.getBinaryContent(url, (err, data) => {
        if (err) {
          reject(err)
        } else {
          resolve(data)
        }
      })
    })
  }

  const zip = new JSZip()
  const urlArray = []
  let url
  cardList?.forEach((item) => {
    urlArray.push(item?.cardCtaURL)
  })
  async function handleDownloadClick() {
    for (let i = 0; i < urlArray.length; i++) {
      url = urlArray[i]

      const filename = (url) => url.split("/").pop()
      zip.file(filename(url), urlToPromise(url), { binary: true })
    }
    zip.generateAsync({ type: "blob" }).then(async (content) => {
      const saveAs = await import("save-as").then((mod) => mod.saveAs)

      saveAs(content, `AllFiles.zip`)
    })
  }
  const cardselector = (cardList, cardType, index) => {
    switch (cardType) {
      case "wmContentCard":
        return (
          <WmContentCard
            cardList={cardList}
            key={index}
            nextImageloadingStrategy={nextImageloadingStrategy}
            nextImagePriority={nextImagePriority}
          />
        )
      case "downloadCard":
        return <Downloadcard cardList={cardList} key={index} />
      case "faqCard":
        return <FaqCard cardList={cardList} key={index} />
      case "gridCard":
        return <GridCard cardList={cardList} key={index} />
      case "profileCard":
        return (
          <ProfileCard
            cardList={cardList}
            collapse={collapseGrid}
            key={index}
          />
        )
      case "productInfoCard":
        return <ProductInfoCard cardList={cardList} key={index} />
      case "serviceSolutionCard":
        return (
          <ServiceSolutionCard
            cardList={cardList}
            collapse={collapseGrid}
            key={index}
          />
        )
      case "contentPreviewCard":
        return listView ? (
          <ContentPreviewList contentPreviewCardsList={cardList} key={index} />
        ) : (
          <ContentPreviewCard
            contentPreviewCardsList={cardList}
            collapse={collapseGrid}
            key={index}
          />
        )
      default:
        return ""
    }
  }
  const componentbackgroundColor = () => {
    let backgroundcolor = ""
    if (backgroundColor === "green1") {
      backgroundcolor = wmColor.green1
    }
    if (backgroundColor === "sand") {
      backgroundcolor = wmColor.sand
    }
    if (backgroundColor === "beige") {
      backgroundcolor = wmColor.beige
    }
    if (backgroundColor === "white") {
      backgroundcolor = wmColor.white
    }

    return backgroundcolor
  }
  const componentCtaButtonText = () => (
    <div
      className={`ctaButton componentCtaButton ${classes.yellowBGColor}${
        collapseCardGrid ? "d-none" : ""
      } ${cardType === "contentPreviewCard" ? classes.contentPreviewCta : ""}`}
    >
      <ButtonPrimary
        analytics_key={analyticsKey}
        onClick={() => handleClick(componentCtaURL)}
        className="maax-font-weight-bold"
      >
        {componentCtaText}
      </ButtonPrimary>
    </div>
  )

  const isOurStoryUrl = pageUrl.includes("/inside-wm/our-story")

  return cardType ? (
    <div
      data-testid="CardGrid"
      id={componentId}
      style={{ backgroundColor: componentbackgroundColor() }}
      inert={isOurStoryUrl ? "" : undefined}
    >
      <div className="container">
        <div className="wrapper">
          <div
            className={`${classes.headingbutton}`}
            data-testid="cardHeading"
            id="cardHeader"
          >
            {componentHeading && (
              <Typography
                variant="h2"
                component="h2"
                tabIndex="0"
                className={`maax-font-weight-bold ${classes.title}`}
                style={{
                  color: backgroundColor === "green1" ? wmColor.white : "",
                }}
              >
                {componentHeading}
              </Typography>
            )}
            <button
              aria-label={
                collapseCardGrid
                  ? `${componentHeading} View All`
                  : `${componentHeading} View Less`
              }
              aria-expanded={!collapseCardGrid}
              type="button"
              className={`${classes.collapsebutton}`}
              onClick={togglecollapsecard}
              tabIndex={0}
              aria-hidden="true"
            >
              {!collapseCardGrid
                ? cardType && (
                    <NextImageWrapper
                      wrapper="span"
                      src={getContentUrl(
                        `/content/dam/wm/icons/controls/20x20/${
                          backgroundColor === "green1" ? `white` : `green`
                        }/collapse.svg`,
                      )}
                      renderLegacyComponent={(props) => <ReactSVG {...props} />}
                      nextImageProps={{
                        height: 36,
                        width: 32,
                        alt: "collapse icon",
                        loading: nextImageloadingStrategy,
                      }}
                    />
                  )
                : cardType && (
                    <NextImageWrapper
                      wrapper="span"
                      src={getContentUrl(
                        `/content/dam/wm/icons/controls/20x20/${
                          backgroundColor === "green1" ? `white` : `green`
                        }/expand.svg`,
                      )}
                      renderLegacyComponent={(props) => <ReactSVG {...props} />}
                      nextImageProps={{
                        height: 36,
                        width: 32,
                        alt: "expand icon",
                        loading: nextImageloadingStrategy,
                      }}
                    />
                  )}
            </button>
          </div>
          <Typography
            component="div"
            className={` ${classes.cardbody}`}
            style={{
              color: backgroundColor === "green1" ? wmColor.white : "",
            }}
          >
            {ReactHtmlParser(body)}
          </Typography>

          <div
            className={` ${
              collapseCardGrid ? classes.collapsed : classes.expanded
            }`}
          >
            <Box
              // flex-wrap applied to collapsed CardGrids is adding a lot of extra height to the page, the fix is to conditionally add it when the CardGrid is expanded
              flexWrap={collapseCardGrid ? "nowrap" : "wrap"}
              className={`d-flex cardWrap ${classes.cardwrapper}`}
              data-testid="ContentCard"
            >
              {cardType === "contentPreviewCard"
                ? map(contentPreviewCardsList, (item, index) =>
                    cardselector(
                      contentPreviewCardsList[index],
                      cardType,
                      index,
                    ),
                  )
                : map(cardList, (item, index) =>
                    cardselector(cardList[index], cardType, index),
                  )}
            </Box>
            {cardType === "downloadCard" ? (
              downloadButtonText ? (
                <div
                  className={`ctaButton componentCtaButton ${
                    classes.yellowBGColor
                  }${collapseCardGrid ? "d-none" : ""}`}
                >
                  <ButtonPrimary
                    analytics_key={analyticsKey}
                    onClick={() => handleDownloadClick()}
                    className="maax-font-weight-bold"
                  >
                    {downloadButtonText}
                  </ButtonPrimary>
                </div>
              ) : (
                componentCtaText && componentCtaURL && componentCtaButtonText()
              )
            ) : (
              componentCtaText && componentCtaURL && componentCtaButtonText()
            )}
          </div>
        </div>
        <div className={`${classes.horizontalline}`} />
      </div>
    </div>
  ) : null
}

// Note: React 19 no-longer supports propTypes. Leaving this for reference.
// CardGrid.propTypes = {
//   cardList: PropTypes.array.isRequired,
//   cardType: PropTypes.string,
//   componentHeading: PropTypes.string,
//   componentCtaText: PropTypes.string,
//   componentCtaURL: PropTypes.string,
//   analyticsKey: PropTypes.string,
//   backgroundColor: PropTypes.string,
//   collapseGrid: PropTypes.bool,
//   downloadButtonText: PropTypes.string,
//   body: PropTypes.string,
//   contentPreviewCardsList: PropTypes.array,
//   listView: PropTypes.bool,
//   componentId: PropTypes.string,
//   nextImageloadingStrategy: PropTypes.string,
//   nextImagePriority: PropTypes.bool,
// }

// Note: React 19 no-longer supports defaultProps. Leaving this for reference.
// CardGrid.defaultProps = {
//   cardType: "",
//   componentHeading: "",
//   componentCtaText: "",
//   componentCtaURL: "",
//   analyticsKey: "",
//   backgroundColor: "",
//   collapseGrid: false,
//   downloadButtonText: "",
//   body: "",
//   contentPreviewCardsList: [],
//   listView: false,
//   componentId: "",
//   nextImageloadingStrategy: `eager`,
//   nextImagePriority: false,
// }

export default CardGrid
